<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Advanced Settings"/>

        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field label="Minutes Required" label-position="inside">
                        <b-input v-model="app.min_minutes_required" placeholder="0"></b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Max Units" label-position="inside">
                        <b-input v-model="app.max_units" placeholder="0"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Flat Price" label-position="inside">
                        <b-input v-model="app.flat_price" placeholder="0.00"></b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Price per Unit" label-position="inside">
                        <b-input v-model="app.per_unit_price" placeholder="0.00"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field>
                        <b-switch v-model="app.is_active">Visible (Active)</b-switch>
                    </b-field>
                </div>
                <div class="column">
                    <b-field>
                        <b-switch v-model="app.is_enabled">Is Enabled</b-switch>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field>
                        <b-switch v-model="app.is_required_at_end">Required (Display Notice)</b-switch>
                    </b-field>
                </div>
            </div>
        </container-list-item>

        <subheader-list-item icon="fa-file-alt" title="Compliance"/>

        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field label="Syllabus" label-position="inside">
                        <b-input type="textarea" v-model="app.syllabus"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Goals" label-position="inside">
                        <b-input type="textarea"v-model="app.goals"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Objectives" label-position="inside">
                        <b-input type="textarea"v-model="app.objectives"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Outcomes" label-position="inside">
                        <b-input type="textarea"v-model="app.outcomes"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Learning Standards" label-position="inside">
                        <b-input type="textarea"v-model="app.standards"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Instructor" label-position="inside">
                        <b-input v-model="app.instructor"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Resume" label-position="inside">
                        <b-input type="textarea" v-model="app.resume"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Expected Participants" label-position="inside">
                        <b-input type="number" v-model="app.num_participants"></b-input>
                    </b-field>
                </div>
            </div>
        </container-list-item>
    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SeparatorListItem from "@/components/common/SeparatorListItem";

    export default {
        name: 'CourseApplicationForm',
        props: {
            app: {
                type: Object,
                required: true
            },
        },
        components: {SeparatorListItem, CardListItem, ContainerListItem, SubheaderListItem, CardList},
        data: function() {
            return {};
        },
        methods: {}
    };
</script>
